import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-prenatal-scans',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './prenatal-scans.component.html',
  styleUrl: './prenatal-scans.component.scss'
})
export class PrenatalScansComponent implements OnInit {
  constructor(private route: Router, private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/prenatal-scans",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);



    this.titleService.setTitle('Prenatal Scans in Kannur | Accurate Pregnancy Ultrasound');
    this.metaService.updateTag({
      name: 'description',
      content: 'Get precise and safe prenatal scans at NCARE IVF Centre in  Kannur. From early pregnancy to growth scans, we ensure the health of both mother and baby with advanced imaging technology.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'prenatal scan, prenatal scans, prenatal scans near me, pregnancy scanning centre kannur, prenatal scans in kannur, ultrasound scan near me'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Prenatal Scans in Kannur | Accurate Pregnancy Ultrasound'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Get precise and safe prenatal scans at NCARE IVF Centre in  Kannur. From early pregnancy to growth scans, we ensure the health of both mother and baby with advanced imaging technology.'
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
